export enum LocaleCode {
  EN = 'en',
  // TODO v1.1: confirm below match backend codes
  FR = 'fr',
  ES_ES = 'es-es',
  ZH_CN = 'zh-cn',
}
